module.exports = __webpack_public_path__ + "static/media/Chris.7c0d01b2.jpg";